// NPM Imports
import React, { Component, lazy } from "react";
import { connect } from "react-redux";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
// import { ICellRendererParams } from "ag-grid-community";
// Component Imports
import FieldsListingHeader from "./FieldsListingHeader";

// Internal Imports
import { AmplitudeUtils } from "../../../utils";
import { EVENTS, FIELDS, LOADING_MSG } from "../../../constants";
import {
  fetchFormFields,
  updateFormFieldsList,
} from "../../../actions/FieldsSetting/fieldsSettingActions";
import { fetchMetaFieldAction } from "../../../actions/MetaFieldActions";
import LZLoader from "../../../commonComponents/LZLoader";
// Component Dynamic Imports
const AgGridWrapper = lazy(() =>
  import(/* webpackChunkName: "ag-grid-wrapper" */ "../../AgGridWrapper"),
);

const { amplitudeLogEvent } = AmplitudeUtils;
const { FIELDS_LISTING_VIEW_COLUMNS } = FIELDS;

class FieldsListing extends Component {
  state = {
    // showLoader: true,
    // currentField: null,
  };

  componentDidMount() {
    document.title = "LegalZoom Form Inspector";

    amplitudeLogEvent(EVENTS.EVENT_NAMES.MY_FIELDS_VIEWED);
  }

  // Callback on ag-grid ready state
  _onGridReady = api => {
    // Resize columns after it's completly loaded
    api.api.sizeColumnsToFit();
  };

  render() {
    // function LinkComponent(props: ICellRendererParams) {
    //   return (
    //     <a
    //       data-test="sdcsdc"
    //       href={`https://yourwebsite/entity/detail?id=${props.value}`}>
    //       Hi
    //     </a>
    //   );
    // }
    // // const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");

    if (this.props.loadingFields) {
      return <LZLoader label={LOADING_MSG.FORM_FIELDS} />;
    }

    return (
      <div className="fields-details-container">
        {/** HEADER SECTION */}
        <section className="fields-header">
          <FieldsListingHeader />
        </section>
        <section className="ag-theme-balham fields-listing-section">
          {/* Table Header */}
          <AgGridWrapper
            // Grid Data
            headerHeight={40}
            columnData={FIELDS_LISTING_VIEW_COLUMNS}
            rowData={this.props.fieldsList}
            // Grid Callbacks
            // onCellValueChanged={this._onCellValueChanged}
            // onDragStopped={this._saveGridState}
            onGridReady={this._onGridReady}
            // onSortChanged={this._saveGridState}
            // Grid Functions
            animateRows
            deltaRowDataMode
            getRowNodeId={data => data.index}
            rowHeight={40}
            suppressDragLeaveHidesColumns
            suppressPropertyNamesCheck
            // frameworkComponents={{
            //   LinkComponent,
            // }}
          />
        </section>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fieldsList, loadingFields } = state.FieldsSettingStore;
  const { template: { fields_used: fieldsUsed, object_id: objectId } = {} } =
    state.TemplateStore;
  const { document: { signatoriesV2: signatories } = {} } = state.DocumentStore;

  return { fieldsList, loadingFields, fieldsUsed, signatories, objectId };
};

const mapDispatchToProps = {
  fetchFormFields,
  updateFormFieldsList,
  fetchMetaFieldAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(FieldsListing);
